import { useEffect, useState } from 'react';
import { useBeautyProduct } from '../../../beauty-shared/context/BeautyProductContext';

function readThemeCtaLabel() {
  if (typeof document === 'undefined') return '';
  return String(document.documentElement.dataset.pageSetupCtaText || '').trim();
}

/**
 * Looks/makeup page copy: product title/description + Workspace Page Setup CTA label when set.
 */
export function useLooksPageCopy() {
  const product = useBeautyProduct();
  const [themeCta, setThemeCta] = useState(readThemeCtaLabel);

  useEffect(() => {
    const sync = () => setThemeCta(readThemeCtaLabel());
    sync();
    const id = window.setInterval(sync, 1500);
    return () => window.clearInterval(id);
  }, []);

  const title = String(product?.title || 'Makeup Looks').trim();
  const description = String(
    product?.description || 'Capture your face, pick a look, and apply full makeup in one tap.',
  ).trim();
  const cta = themeCta || String(product?.cta || 'Continue').trim() || 'Continue';

  return { title, description, cta, product };
}
